import styled from "styled-components";

export const Text = styled.p`
  font-size: 1.1rem;
`;
